module.exports = __webpack_public_path__ + "static/fonts/gilroy-black.19d313b.otf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/gilroy-black.otf
// module id = DHk0
// module chunks = 28